import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { INITIAL_BASIC_INFO } from './consts';
import {
  reset,
  setBasicInfo,
  setPolicies,
  setUsers,
  setLoading
} from './actions';

const basicInfoReducer = handleActions(
  {
    [setBasicInfo.toString()]: (_, { payload: basicInfo }) => basicInfo,
    [reset.toString()]: () => INITIAL_BASIC_INFO
  },
  INITIAL_BASIC_INFO
);

const usersReducer = handleActions(
  {
    [setUsers.toString()]: (_, { payload: users }) => users,
    [reset.toString()]: () => []
  },
  []
);

const policiesReducer = handleActions(
  {
    [setPolicies.toString()]: (_, { payload: policies }) => policies,
    [reset.toString()]: () => []
  },
  []
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload: loading }) => loading,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  basicInfo: basicInfoReducer,
  users: usersReducer,
  policies: policiesReducer,
  loading: loadingReducer
});
